import { render } from "./history-item.vue?vue&type=template&id=0e5dac2e&scoped=true&ts=true"
import script from "./history-item.vue?vue&type=script&lang=ts"
export * from "./history-item.vue?vue&type=script&lang=ts"

import "./history-item.vue?vue&type=style&index=0&id=0e5dac2e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5dac2e"]])

export default __exports__